import BaseObject from "../../../base/base_object";
import Event, {SystemEventSubscription} from "../../../utils/event";
import {SYSTEM_EVENTS} from "../../../events/events";
import {TimeSpan} from "@sparkware/app-utils";
import ServiceFactory from "../../service_factory";
import {IObservableSubscription} from '../../../utils/observable';

const SESSION_TIMER_INCREMENT_INTERVAL = TimeSpan.fromSeconds(1);
const HEART_BEAT_INTERVAL = TimeSpan.fromMinutes(5);


interface SessionTimerLogicHelperParams {
    serviceFactory: ServiceFactory
}

export default class SessionTimerLogicHelper extends BaseObject {
    static CLASS = 'SessionTimerLogicHelper';

    _sessionTime = TimeSpan.fromMinutes(0);
    _sessionTimerObservable: IObservableSubscription = null;
    _heartBeatObservable: IObservableSubscription = null;
    _serviceFactory: ServiceFactory;

    init(params: SessionTimerLogicHelperParams) {
        super.init(params);

        params = params || ({} as SessionTimerLogicHelperParams);
        this._serviceFactory = params.serviceFactory || ServiceFactory.create();

    }

    private _focusGainSubscription: SystemEventSubscription = null;
    _subscribe(): void {
        this._focusGainSubscription = Event.on(SYSTEM_EVENTS.WINDOW_FOCUS_GAIN, this._readSessionTimeFromServer, this);
    }

    _unsubscribe() : void {
        if (this._focusGainSubscription) {
            this._focusGainSubscription.off();
            this._focusGainSubscription = null;
        }
    }

    start(): void {
        if(this._sessionTimerObservable) {
            this.stop();
        }

        this._startHeartBeat();
        this._startSessionTime();
        this._readSessionTimeFromServer();
        this._subscribe();
    }

    stop(): void {
        this._stopHeartBeat();
        this._stopSessionTimer();
    }

    dispose(): void {
        this.stop();
        this._unsubscribe();
        this._sessionTime = TimeSpan.fromMinutes(0);
    }

    getSessionTime(): TimeSpan {
        return this._sessionTime;
    }

    private _readSessionTimeFromServer() {
        this._serviceFactory.oAuth2Service().getTimeSinceLogin().then(sessionTime => {
            this._sessionTime = sessionTime;
            this._fireUpdateEvent();
        });
    }

    private _startSessionTime() {
        this._sessionTimerObservable = this._serviceFactory.observableFactoryService().fromInterval(SESSION_TIMER_INCREMENT_INTERVAL.totalMilliseconds, 'SESSION_TIMER_INCREMENT_INTERVAL')
            .forEach(() => {
                this._sessionTime = this._sessionTime.add(SESSION_TIMER_INCREMENT_INTERVAL);
                this._fireUpdateEvent();
            });
    }

    private _stopSessionTimer() {
        if(this._sessionTimerObservable) {
            this._sessionTimerObservable.dispose();
            this._sessionTimerObservable = null;
        }
    }

    private _startHeartBeat() {
        this._heartBeatObservable = this._serviceFactory.observableFactoryService().fromInterval(HEART_BEAT_INTERVAL.totalMilliseconds, "SESSION_TIMER_HEART_BEAT_INTERVAL")
            .forEach(() => {
                this._readSessionTimeFromServer();
            });
    }

    private _stopHeartBeat() {
        if (this._heartBeatObservable) {
            this._heartBeatObservable.dispose();
            this._heartBeatObservable = null;
        }
    }

    private _fireUpdateEvent() {
        Event.fire(SYSTEM_EVENTS.SESSION_TIMER_UPDATE, {
            sessionTime: this._sessionTime
        });
    }
}